import {size} from "../../../models/size";
import {NavLink, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {ApiError, ApiQueryParam, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";
import {Require} from "../Require";
import {bodyArea} from "../../../models/bodyArea";
import {bodyAreaResultCollectionType, bodyAreaResultType} from "../../../types/Api/BodyAreaResultType";
import {bodyAreaHydrator} from "../../../models/hydrator/bodyAreaHydrator";
import {Loader} from "../Loader";

type FormDataType = {
  label: string,
  bodyArea: string[],
}

type SizeFormProp = {
  size?: size
}

export const SizeForm = ({size}: SizeFormProp) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [bodyAreaOptions, setBodyAreaOptions] = useState([] as bodyArea[]);

  const {
    register,
    handleSubmit,
    setError,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      label: size?.label,
      bodyArea: size ? size.bodyArea.map((bodyArea) => bodyArea.bodyAreaId) : [],
    }
  });

  useEffect(() => {
    const apiFiltersSize: ApiQueryParam = new ApiQueryParam();

    apiFiltersSize.setCount(0);
    apiFiltersSize.addSort({
      by: "label",
      direction: "ASC"
    });

    const resultCollection = ApiService.get(`/body-area`, apiFiltersSize) as Promise<bodyAreaResultCollectionType>;

    setLoading(true);

    resultCollection
      .then((r) => {
        setBodyAreaOptions(r._embedded["body-areas"].map((bodyArea: bodyAreaResultType) => {
          return bodyAreaHydrator.hydrate(bodyArea);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = async (data: FormDataType) => {
    const apiData = {
      label: data.label,
      bodyArea: data.bodyArea,
    };

    try {
      size
        ? await ApiService.patch(`/size/${size.sizeId}`, {param: () => apiData})
        : await ApiService.post('/size', {param: () => apiData});

      navigate('/admin/equipment/size');
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "label" | "bodyArea", {
          type: "manual",
          message: e.message
        })
      });
    }
  }

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (
        <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex flex-wrap">
            <div className="col min-w400px max-w600px pe-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="form-name">Nom <Require/></label>
                <input id="form-name" type="text" className="form-control" placeholder="~" {...register('label', {
                  required: 'Le nom est obligatoire',
                  validate: {
                    minLength: (value) =>
                      (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
                  },
                })} />
                {errors.label && <p className="text-danger">{errors.label.message}</p>}
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="form-bodyarea">Zone du corps <Require/></label>

                <div className="d-flex">
                  {bodyAreaOptions.map((bodyAreaOption, k) => (
                    <div key={k} className="form-check me-3">
                      <input className="form-check-input" type="checkbox" id={`form-bodyarea-${k}`} value={bodyAreaOption.bodyAreaId} {...register('bodyArea', {
                        required: 'La zone du corps est obligatoire',
                      })}/>
                      <label className="form-check-label" htmlFor={`form-bodyarea-${k}`}>
                        {bodyAreaOption.label}
                      </label>
                    </div>
                  ))}
                </div>

                {errors.bodyArea && <p className="text-danger">{errors.bodyArea.message}</p>}
              </div>
            </div>
          </div>

          <div className="mt-3">
            <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
            <NavLink to={`/admin/equipment/size`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux tailles</NavLink>
          </div>
        </form>
      )}
    </>
  )
}
